import { __awaiter } from "tslib";
import { getCanvasDataToClipboard } from './../utils/clipboard';
import { useEffect } from 'react';
import { useState } from 'react';
import { useCanvasInstance, useCanvasModel, useCommand, useOFlowModel } from './useModel';
import { Layout } from 'butterfly-dag';
import $ from 'jquery';
// 多选模式下，鼠标跟随的DOM
const createMultipleSelectTraceDom = (graphId) => {
    if (document.getElementById(`${graphId}_mouse_multiple_selected_trace_dom`)) {
        return;
    }
    else {
        const dom = $(document.createElement('div'))
            .attr('id', `${graphId}_mouse_multiple_selected_trace_dom`)
            .css({
            height: 10,
            width: 10,
            border: '1px dashed #000',
            backgroundColor: '#D8D8D8',
            position: 'fixed',
            left: -999,
            top: -999,
        });
        document.body.append(dom[0]);
    }
};
const getMultipleSelectTraceDom = (graphId) => {
    return document.getElementById(`${graphId}_mouse_multiple_selected_trace_dom`);
};
const removeMultipleSelectTraceDom = (graphId) => {
    if (document.getElementById(`${graphId}_mouse_multiple_selected_trace_dom`)) {
        $(document.getElementById(`${graphId}_mouse_multiple_selected_trace_dom`)).remove();
    }
};
export const useCanvasActions = (canvasId) => {
    const oFlowModel = useOFlowModel();
    const canvasInstance = useCanvasInstance({ canvasId });
    const canvasModel = useCanvasModel({ canvasId });
    const command = useCommand({ canvasId });
    const editable = oFlowModel.getEditable();
    // 历史记录 —— 撤销、重做
    const [couldCanvasUndo, setCouldCanvasUodo] = useState(false);
    const [couldCanvasRedo, setCouldCanvasRedo] = useState(false);
    // 多选
    const [couldMultipleSelect, setCouldMutipleSelect] = useState(true);
    const [couldDelete, setCouldDelete] = useState(false);
    // 复制
    const [couldCopy, setCouldCopy] = useState(false);
    const [couldPaste, setCouldPaste] = useState(false);
    // 布局方向
    const [layoutType, setLayoutType] = useState('vertical');
    const [disableChangeRankDirection, setDisableChangeRankDirection] = useState(false);
    useEffect(() => {
        const fn = () => {
            var _a, _b;
            if (canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.rankConfig) {
                setLayoutType((_a = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.rankConfig) === null || _a === void 0 ? void 0 : _a.direction);
                setDisableChangeRankDirection((_b = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.rankConfig) === null || _b === void 0 ? void 0 : _b.disableChangeDirection);
            }
        };
        canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.onRankConfigChange(fn);
        fn();
        return () => {
            canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.remvoeRankConfigChange(fn);
        };
    }, [canvasModel]);
    useEffect(() => {
        var _a, _b;
        const commandHistoryListener = () => {
            const historyModel = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.commandHistoryModel;
            setCouldCanvasRedo(historyModel === null || historyModel === void 0 ? void 0 : historyModel.couldRedoCommand);
            setCouldCanvasUodo(historyModel === null || historyModel === void 0 ? void 0 : historyModel.couldUndoCommand);
        };
        const elementSelectListener = () => {
            const selectedElements = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.getSelectedElements();
            let couldDelete = false;
            let couldCopy = false;
            selectedElements === null || selectedElements === void 0 ? void 0 : selectedElements.forEach(instance => {
                if (instance.couldDelete) {
                    couldDelete = true;
                }
                if (instance.couldCopy) {
                    couldCopy = true;
                }
            });
            setCouldDelete(couldDelete);
            setCouldCopy(couldCopy);
        };
        (_a = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.eventCenter) === null || _a === void 0 ? void 0 : _a.on('COMMAND_HISTORY_CHANGE', commandHistoryListener);
        canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.eventCenter.on('ELEMENT_SELECT', elementSelectListener);
        elementSelectListener();
        commandHistoryListener();
        // @ts-ignore
        (_b = canvasInstance === null || canvasInstance === void 0 ? void 0 : canvasInstance.FlowCanvasInstance) === null || _b === void 0 ? void 0 : _b.on('system.multiple.select', (e) => {
            setCouldMutipleSelect(true);
        });
        return () => {
            canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.eventCenter.off('COMMAND_HISTORY_CHANGE', commandHistoryListener);
            canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.eventCenter.off('ELEMENT_SELECT', elementSelectListener);
        };
    }, [canvasModel]);
    // 监听鼠标移动
    useEffect(() => {
        const canvasRootDom = canvasInstance === null || canvasInstance === void 0 ? void 0 : canvasInstance.canvasDomRef.current;
        const canvasId = canvasInstance === null || canvasInstance === void 0 ? void 0 : canvasInstance.canvasId;
        const mouseMoveListener = (e) => {
            // 鼠标在画布里移动
            if (canvasInstance.mouseInCanvas) {
                $(getMultipleSelectTraceDom(canvasId)).css({
                    left: e.clientX + 10,
                    top: e.clientY + 10,
                });
            }
            else {
                $(getMultipleSelectTraceDom(canvasId)).css({
                    left: -999,
                    top: -999,
                });
            }
        };
        const mouseDownListener = (e) => {
            // 鼠标在画布里进行框选
            if (canvasInstance.mouseInCanvas) {
                removeMultipleSelectTraceDom(canvasId);
            }
        };
        if (canvasRootDom) {
            // 开始框选
            if (!couldMultipleSelect) {
                createMultipleSelectTraceDom(canvasId);
                // 设置鼠标形状
                $(canvasRootDom).css({
                    cursor: 'default',
                });
                window.addEventListener('mousemove', mouseMoveListener);
                window.addEventListener('mousedown', mouseDownListener);
            }
            else {
                // 移除鼠标css
                $(canvasRootDom).css({
                    cursor: '',
                });
            }
        }
        return () => {
            if (!canvasRootDom)
                return;
            removeMultipleSelectTraceDom(canvasId);
            window.removeEventListener('mousemove', mouseMoveListener);
            window.removeEventListener('mousedown', mouseDownListener);
        };
    }, [couldMultipleSelect, canvasModel]);
    const canvasUndoAction = {
        visible: editable,
        disabled: !couldCanvasUndo,
        action: () => {
            command.undo();
        },
    };
    const canvasRedoAction = {
        visible: editable,
        disabled: !couldCanvasRedo,
        action: () => {
            command.redo();
        },
    };
    const canvasDeleteAction = {
        visible: editable,
        disabled: !couldDelete,
        action: () => __awaiter(void 0, void 0, void 0, function* () {
            yield command.execute('BATCH_DELETE_ELEMENTS', {
                payload: canvasModel.selectedElementsId,
            });
            // 清理选中的
            yield command.execute('BATCH_SELECT_ELEMENTS', { payload: [] });
        }),
    };
    const canvasMultipleSelectAction = {
        visible: editable,
        disabled: !couldMultipleSelect,
        action: () => {
            setCouldMutipleSelect(false);
            canvasInstance.openMultipleSelect();
        },
    };
    const canvasZoomUpAction = {
        visible: true,
        action: () => {
            const preZoom = canvasInstance.getZoom();
            const newZoom = preZoom + 0.1;
            canvasInstance.zoom(newZoom);
        },
    };
    // 缩小
    const canvasZoomDownAction = {
        visible: true,
        action: () => {
            const preZoom = canvasInstance.getZoom();
            const newZoom = preZoom - 0.1;
            canvasInstance.zoom(newZoom);
        },
    };
    const canvasAutoZoomAction = {
        visible: true,
        action: () => {
            canvasInstance.focusCenterWithAnimate();
        },
    };
    const canvasSelectAllAction = {
        visible: true,
        action: () => {
            const { nodes, edges, groups } = canvasModel.getCanvasData();
            let selectedIds = [];
            nodes.forEach(item => selectedIds.push(item.id));
            edges.forEach(item => selectedIds.push(item.id));
            groups.forEach(item => selectedIds.push(item.id));
            command.execute('BATCH_SELECT_ELEMENTS', { payload: selectedIds });
        },
    };
    // 自动布局
    const canvasVerticalLayout = {
        visible: disableChangeRankDirection ? layoutType === 'vertical' : true,
        actived: disableChangeRankDirection ? false : layoutType === 'vertical',
        action: () => __awaiter(void 0, void 0, void 0, function* () {
            const { nodesep, levelSpacing, direction } = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.rankConfig;
            const { nodes: newPosNodes, edges: newPosEdges } = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.getCanvasData();
            Layout.dagreLayout({
                rankdir: 'TB',
                nodesep,
                ranksep: levelSpacing,
                controlPoints: false,
                data: {
                    nodes: newPosNodes,
                    edges: newPosEdges,
                },
            });
            const { nodes, edges } = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.getCanvasData();
            nodes === null || nodes === void 0 ? void 0 : nodes.forEach((item, index) => {
                item['left'] = newPosNodes[index].left;
                item['top'] = newPosNodes[index].top;
            });
            if (direction !== 'vertical') {
                yield command.execute('DREW_ELEMENTS', { payload: { nodes: [], edges: [] } });
                canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.setRankConfig({ direction: 'vertical' });
            }
            yield command.execute('DREW_ELEMENTS', { payload: { nodes, edges } });
            // 面板异步关闭后，进行剧中
            setTimeout(() => {
                command.execute('FOCUS_CENTER_ELEMENTS');
            }, 20);
            setLayoutType('vertical');
        }),
    };
    const canvasHorizontalLayout = {
        visible: disableChangeRankDirection ? layoutType === 'horizontal' : true,
        actived: disableChangeRankDirection ? false : layoutType === 'horizontal',
        action: () => __awaiter(void 0, void 0, void 0, function* () {
            const { nodesep, levelSpacing, direction } = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.rankConfig;
            const { nodes: newPosNodes, edges: newPosEdges } = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.getCanvasData();
            Layout.dagreLayout({
                rankdir: 'LR',
                nodesep,
                ranksep: levelSpacing,
                controlPoints: false,
                data: {
                    nodes: newPosNodes,
                    edges: newPosEdges,
                },
            });
            const { nodes, edges } = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.getCanvasData();
            nodes === null || nodes === void 0 ? void 0 : nodes.forEach((item, index) => {
                item['left'] = newPosNodes[index].left;
                item['top'] = newPosNodes[index].top;
            });
            if (direction !== 'horizontal') {
                yield command.execute('DREW_ELEMENTS', { payload: { nodes: [], edges: [] } });
                canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.setRankConfig({ direction: 'horizontal' });
            }
            yield command.execute('DREW_ELEMENTS', { payload: { nodes, edges } });
            setLayoutType('horizontal');
            // 面板异步关闭后，进行剧中
            setTimeout(() => {
                command.execute('FOCUS_CENTER_ELEMENTS');
            }, 20);
        }),
    };
    const canvasCopyAction = {
        visible: editable,
        disabled: !couldCopy,
        action: () => __awaiter(void 0, void 0, void 0, function* () {
            yield command.execute('BATCH_COPY_ELEMENTS', {
                payload: canvasModel.selectedElementsId,
            });
            setCouldPaste(true);
        }),
    };
    const canvasPasteAction = {
        visible: editable,
        disabled: !couldPaste,
        action: () => __awaiter(void 0, void 0, void 0, function* () {
            const canvasData = yield getCanvasDataToClipboard(oFlowModel);
            if (canvasData) {
                command.execute('BATCH_PASTE_ELEMENTS', { payload: canvasData });
            }
            else {
                setCouldPaste(false);
            }
        }),
    };
    const canvasDuplicateAction = {
        visible: editable,
        disabled: !couldCopy,
        action: () => {
            command.execute('BATCH_PASTE_ELEMENTS', {
                payload: canvasModel.generatePasteElementConfigByIds(canvasModel.selectedElementsId),
            });
        },
    };
    return {
        canvasUndoAction,
        canvasRedoAction,
        canvasDeleteAction,
        canvasMultipleSelectAction,
        canvasZoomUpAction,
        canvasZoomDownAction,
        canvasAutoZoomAction,
        canvasSelectAllAction,
        canvasCopyAction,
        canvasPasteAction,
        canvasDuplicateAction,
        canvasVerticalLayout,
        canvasHorizontalLayout,
    };
};
//# sourceMappingURL=useCanvasActions.js.map